import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS_EMAIL_HREF } from '../data/contact';
import { trackEvent } from '../utils/analytics';
export function BuyersAgentSection() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState(false);
  return <section className="w-full bg-white pb-20 lg:pb-28" data-id="element-93" data-mp="2uuxrludrj1fc">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-94" data-mp="3rjnczuolmc62">
        <div className="border border-soft-gray" data-id="element-95" data-mp="3rh149rpz1qm9">
          <h2 data-id="element-96" data-mp="3nitksp44ib7d">
            <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="buyers-agent-panel" className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left lg:px-8" data-id="element-97" data-mp="3nia3namarque">
              <span className="label-caps text-midnight" data-id="element-98" data-mp="274tpjrg839qg">
                {t("For Buyer's Agents", 'Para Agentes de Compradores')}
              </span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-99" data-mp="t6idjxyp3bbb" />
            </button>
          </h2>

          {open && <div id="buyers-agent-panel" className="border-t border-soft-gray px-5 py-6 lg:px-8" data-id="element-100" data-mp="o75pxb00207o">
              <p className="max-w-3xl text-[14px] leading-relaxed text-ink/80" data-id="element-101" data-mp="9isr869j239h">
                {t('Buyer-agent compensation information and the applicable compensation agreement are available upon request. Compensation is negotiable and subject to the terms authorized by the seller and listing brokerage.', 'La información sobre una posible compensación para el agente del comprador y el acuerdo correspondiente están disponibles previa solicitud. La compensación es negociable y está sujeta a los términos autorizados por el vendedor y la brokerage que representa la propiedad.')}
              </p>
              <a href={`${BUSINESS_EMAIL_HREF}?subject=${encodeURIComponent(t('Compensation information request — 1039 Plantation Ln', 'Solicitud de información de compensación — 1039 Plantation Ln'))}`} onClick={() => trackEvent('email_click', {
            location: 'buyers_agent'
          })} className="mt-6 inline-block border border-midnight/25 px-6 py-3.5 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-midnight transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-102" data-mp="38m575hsrbj3t">
                {t('Request Compensation Information', 'Solicitar Información de Compensación')}
              </a>
              <p className="mt-4 text-[12px] text-ink/60" data-id="element-103" data-mp="267523w80p4l6">
                Veronica Gomez Santana •{' '}
                {t('Affiliated with Avanti Way Realty LLC', 'Afiliada a Avanti Way Realty LLC')}
              </p>
            </div>}
        </div>
      </div>
    </section>;
}